// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zCZL","label":"styles_label__oEF_J"};